import { createFilter } from 'react-select';
import { SelectOption } from '../../types/select';

export const getFilterOption = <T extends SelectOption>() =>
  createFilter<T>({
    stringify: ({ data }) =>
      data.searchString ?? (typeof data.label === 'string' ? (data.label as string) : data.value ?? ''),
  });
